module.exports = __webpack_public_path__ + "static/sign-up-form-1-3-3b5208de60b425cbcf41c46c90b0eee3.png";